import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import moment from 'moment';
import dashboardActions from '../../actions/dashboard.actions';
import settingsActions from '../../actions/settings.actions';
import {
    Header,
    GraphsSection,
    EarningSection,
    LoadIndicator,
    Login,
    Footer,
    Disclaimer
} from '../../components';
import styles from './Dashboard.pcss';
import {RedirectWithParams, Message} from 'epic-diesel-common';
import SmartUpdatedAgreementDialog from '../../components/eula/SmartUpdatedAgreementDialog';

const mapStateToProps = state => ({
    messages: state.get('localization').get('messageProperties'),
    dashboardState: state.get('dashboard'),
    userState: state.get('user').toJS(),
    settingsState: state.get('settings').toJS(),
    influencerState: state.get('influencer').toJS(),
    configState: state.get('config').toJS()
});
const mapDispatchToProps = dispatch => ({
    getSettings: () => {
        dispatch(settingsActions.getSettings());
    },
    getDashboardData: data => {
        dispatch(dashboardActions.getDashboardData(data));
    },
    updatePayout: data => {
        dispatch(dashboardActions.updatePayout(data));
    }
});

class Dashboard extends React.Component {
    static propTypes = {
        messages: PropTypes.object,
        getDashboardData: PropTypes.func,
        dashboardState: PropTypes.object,
        updatePayout: PropTypes.func,
        getSettings: PropTypes.func,
        influencerState: PropTypes.object,
        settingsState: PropTypes.object,
        userState: PropTypes.object,
        configState: PropTypes.object
    };

    componentDidMount() {
        const {isLoggedIn} = this.props.userState.accountInfo;
        if (isLoggedIn) {
            this.props.getDashboardData({
                aggregation: 'daily',
                endDate: moment().format('YYYY-MM-DD'),
                startDate: moment()
                    .add(-1, 'months')
                    .format('YYYY-MM-DD'),
                sort: 'ASC',
                count: 1000
            });
            this.props.getSettings();
        }
    }

    onChange = ({from, to}) => {
        const aggregation = 'daily';
        // aggregation = 'weekly';
        // aggregation = 'monthly';
        this.props.getDashboardData({
            aggregation,
            startDate: from,
            endDate: to,
            sort: 'ASC',
            count: 1000
        });
    };

    render() {
        const dashboardData = this.props.dashboardState && this.props.dashboardState.toJS();
        const {influencerState, settingsState, userState, messages, configState} = this.props;

        const {affiliateAccount} = influencerState;
        const {accountInfo} = userState;
        const {epicFooter} = configState;
        const {payoutAccount, taxInfo} = settingsState;
        const isDraft =
            (payoutAccount && payoutAccount.accountStatus === 'DRAFT') ||
            (taxInfo && taxInfo.status === 'DRAFT');

        // If the affiliate has not been approved, redirect to home page
        if (!affiliateAccount || affiliateAccount.status !== 'ACTIVE') {
            return <RedirectWithParams to="/affiliate/overview" />;
        }

        return (
            <div>
                <Header
                    messages={messages}
                    headerClass={styles.header}
                    affiliateAccount={affiliateAccount}
                    accountInfo={accountInfo}
                    configState={configState}
                />
                <div className={styles.container}>
                    <Login isLoggedIn={accountInfo.isLoggedIn}>
                        <LoadIndicator isLoading={dashboardData.loading} messages={messages}>
                            <SmartUpdatedAgreementDialog />
                            <Disclaimer isLoading={dashboardData.loading} theme="fortnite" />{' '}
                            {/*remove theme prop will fall back to use diesal theme */}
                            {isDraft && (
                                <div className={styles.payoutWarning}>
                                    <Message code="epic.affiliate.earnings.payout_warning" />
                                </div>
                            )}
                            <GraphsSection
                                className={styles.content}
                                onChange={this.onChange}
                                sectionData={dashboardData.dashboard}
                                loading={dashboardData.loading}
                                enableLink={true}
                                showLink={!settingsState.loading}
                                messages={messages}
                            />
                            <EarningSection
                                className={styles.sidebar}
                                sectionData={dashboardData.earnings}
                                profile={dashboardData.profile}
                                updatePayout={this.props.updatePayout}
                                affiliateAccount={affiliateAccount}
                                messages={messages}
                            />
                        </LoadIndicator>
                    </Login>
                </div>
                <Footer content={epicFooter} messages={messages} accountInfo={accountInfo} />
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Dashboard);
